import * as React from "react";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import Stack from "@mui/material/Stack";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import { useStore } from "../../contexts/store-provider";
import { observer } from "mobx-react";
import "dayjs/locale/en";
import "dayjs/locale/ja";

interface DateFieldProps {
  value: string | null;
  onChange: (date: string) => void;
  min?: string;
  max?: string;
  disableFuture?: boolean;
}

const CustomDatePicker = ({
  value,
  onChange,
  min,
  max,
  disableFuture,
}: DateFieldProps) => {
  const { preferencesStore } = useStore();
  const handleDateChange = (newValue: Dayjs | null) => {
    if (newValue && newValue.isValid()) {
      onChange(newValue.toISOString());
    } else {
      onChange("");
    }
  };

  const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale={preferencesStore.getLanguage === "en" ? "en" : "ja"}
    >
      <Stack spacing={3}>
        <DesktopDatePicker
          inputFormat="YYYY/MM/DD"
          value={value ? dayjs(value) : null}
          onChange={handleDateChange}
          disableFuture={disableFuture}
          minDate={min ? dayjs(min) : undefined}
          maxDate={max ? dayjs(max) : undefined}
          renderInput={(params: any) => (
            <TextField
              {...params}
              onKeyDown={onKeyDown}
              inputProps={{ ...params.inputProps, readOnly: true, disabled: true }}
            />

          )}
        />
      </Stack>
    </LocalizationProvider>
  );
};
export default CustomDatePicker;
